"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePastDate = void 0;
const common_1 = require("@nestjs/common");
const validatePastDate = (value, fieldName) => {
    if (value === null || value === undefined) {
        return value;
    }
    const date = new Date(value);
    const isValidDate = date instanceof Date &&
        !isNaN(date.getTime()) &&
        value === date.toISOString().split("T")[0];
    if (!isValidDate) {
        throw new common_1.BadRequestException(`The ${fieldName} is invalid. Please provide a valid date in the format YYYY-MM-DD.`);
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of the day
    if (date >= today) {
        throw new common_1.BadRequestException(`The ${fieldName} cannot be a future date. Please provide a valid past date.`);
    }
    return value;
};
exports.validatePastDate = validatePastDate;
